export var ContractEnum;
(function (ContractEnum) {
    ContractEnum["CDI"] = "cdi";
    ContractEnum["CDD"] = "cdd";
    ContractEnum["Stage"] = "stage";
    ContractEnum["Professionalisation"] = "professionalisation";
    ContractEnum["Apprentissage"] = "apprentissage";
    ContractEnum["Interim"] = "interim";
    ContractEnum["Saisonnier"] = "saisonnier";
    ContractEnum["Intermittent"] = "intermittent";
    ContractEnum["Freelance"] = "freelance";
    ContractEnum["These"] = "these";
})(ContractEnum || (ContractEnum = {}));
//# sourceMappingURL=contract.enum.js.map